//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getTimePeriodByName, simpleTimePeriods, timePeriods } from '@/helpers/time';
import DpOption from '../select/Option.vue';
import DpOptionGroup from '../select/OptionGroup.vue';
import DpSelect from '../select/Select.vue';

export default {
  name: 'DpTimeSelect',
  components: {
    DpSelect,
    DpOption,
    DpOptionGroup,
  },
  props: {
    size: { type: String, default: '' },
    value: { type: Object, default: () => null },
    clearable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },
    kpi: { type: Object, default: null },
    tooltip: { type: String, default: null },
    minOffset: { type: Number, default: null },
    disableTooltip: { type: Boolean, default: false },
    useSimpleTimes: { type: Boolean, default: false },
  },
  data() {
    return {
      currentValue: this.value,
      disabledOffset: 0,
      timePeriods,
      simpleTimePeriods,
    };
  },
  computed: {
    computedTooltip() {
      if (this.disableTooltip) return null;
      return this.tooltip || 'Choose a time period to display data for';
    },
    disabledOptions() {
      return ['last3h'];
    },
    placeholderText() {
      if (this.placeholder) {
        return this.placeholder;
      }

      return this.$t('ui.chooseTime');
    },
    parsedTimePeriods() {
      return this.timePeriods.map((t) => {
        const time = {
          ...t,
          disabled: false,
        };

        if (time.offset <= this.disabledOffset) {
          time.disabled = true;
        }

        return time;
      }).filter((t) => {
        if (this.minOffset) {
          return t.offset >= this.minOffset;
        }
        return true;
      });
    },
    firstTimePeriodColumn() {
      return this.parsedTimePeriods.filter((p) => p.column === 2);
    },
    secondTimePeriodColumn() {
      return this.parsedTimePeriods.filter((p) => p.column === 1);
    },
  },
  watch: {
    value(val) {
      if (!val) {
        this.setCurrentValue(null);
        return;
      }

      if (typeof val === 'object' && val.selected !== undefined) {
        delete val.selected; // eslint-disable-line no-param-reassign
        delete val.disabled; // eslint-disable-line no-param-reassign
      }

      if (val && val.name) {
        this.setCurrentValue(getTimePeriodByName(val.name));
      } else {
        this.setCurrentValue(null);
      }
    },
    kpi() {
      this.handleKpiChange();
    },
  },
  mounted() {
    this.setCurrentValue(this.value);
    this.handleKpiChange();
  },
  methods: {
    setCurrentValue(value) {
      this.currentValue = value;
    },
    handleInput(newVal) {
      this.$emit('input', newVal);
      this.setCurrentValue(newVal);
    },
    async handleKpiChange() {
      if (!this.kpi) {
        this.disabledOffset = 0;
        return;
      }

      await this.$nextTick();

      const { kpiQuery } = this.kpi.getQueries();
      const {
        filterStr = '',
        valueFilterStr = '',
        keyFilterStr = '',
      } = kpiQuery;
      const fullString = `${filterStr} ${valueFilterStr} ${keyFilterStr}`;
      const matches = fullString.match(/ago\((.*?)\)/g);

      if (!matches || matches.length === 0) {
        this.disabledOffset = 0;
        return;
      }

      let highestTimeout = 0;
      matches.forEach((m) => {
        const number = parseInt(m.replace('ago(', '').replace(')', ''), 10);
        if (number > highestTimeout) {
          highestTimeout = number;
        }
      });

      this.disabledOffset = highestTimeout * 1000;

      const { currentValue, parsedTimePeriods } = this;
      const currentTime = parsedTimePeriods.filter((t) => t.offset === currentValue.offset)[0];

      if (currentTime && !currentTime.disabled) {
        return;
      }

      for (let i = 0; i < parsedTimePeriods.length; i += 1) {
        const p = parsedTimePeriods[i];
        if (!p.disabled) {
          this.setCurrentValue(p);
          this.handleChange(p);
          break;
        }
      }
    },
    handleChange(newVal) {
      const output = newVal;
      if (output !== null) {
        delete output.disabled;
      }
      this.$emit('change', output);
    },
  },
};
